export enum State {
    Running = "RUNNING",
    Stopped = "STOPPED",
}
